<template>
  <Modal
    :modal-style="{ width: '500px' }"
    title="Upload Annotated PDF"
  >
    <FileUpload
      v-model="attachments"
      accept=".pdf"
      attachment-field="attachments"
      label="Select File"
      :max-file-size="maxFileSize"
      @delete="destroyAttachment"
      @update:model-value="onAttachmentAdded"
    >
      <span class="q-pl-md">Limited to 50MB</span>
    </FileUpload>
    <template #buttons="{ close }">
      <QBtn
        class="q-mr-sm"
        label="Cancel"
        @click.prevent="close"
      />

      <QBtn
        color="primary"
        label="Save Attachments"
        @click="saveAttachments(close)"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import FileUpload from "shared/components/FileUpload";
import { ONE_MB_IN_BYTES } from "shared/constants";

export default {
  name: "AnnotatedPdfUploadModal",
  components: {
    FileUpload,
    Modal,
  },
  props: {
    insightsReport: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      attachments: [],
    };
  },
  computed: {
    maxFileSize() {
      return ONE_MB_IN_BYTES * 50;
    },
  },
  methods: {
    onAttachmentAdded(newAttachment) {
      // make sure we remove existing files
      this.insightsReport.activeStorageAttachments.forEach((file) =>
        Object.assign(file, { isMarkedForDestruction: true })
      );

      this.insightsReport.activeStorageAttachments.push(newAttachment);
    },
    destroyAttachment(attachment) {
      Object.assign(attachment, { isMarkedForDestruction: true });
    },
    async saveAttachments(close) {
      try {
        await this.insightsReport.saveResource({
          with: "activeStorageAttachments",
        });

        this.$q.notify("File successfully uploaded");
      } catch (error) {
        this.$error("Unable to update Annotated PDF", error);
      } finally {
        close();
      }
    },
  },
};
</script>
